package org.braunequip.web.pages

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.navigation.OpenLinkStrategy
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.braunequip.web.components.layouts.PageLayout
import org.braunequip.web.util.Theme
import org.braunequip.web.styles.smallListStyle
import org.braunequip.web.styles.smallPDFBoxStyle
import org.braunequip.web.styles.toSitePalette
import org.braunequip.web.util.Constants
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*

@Page
@Composable
fun CareersPage() {
    val sitePalette = ColorMode.current.toSitePalette() //Not needed yet, need to set values in SiteTheme.kt
    val context = rememberPageContext()

    PageLayout("Careers") {

        Section(Modifier.classNames("hero").backgroundColor(Theme.Primary.rgb).toAttrs()) {
            Div(Modifier.classNames("container", "is-widescreen").toAttrs()) {
                Div(Modifier.classNames("hero-body", "has-text-centered").toAttrs()) {
                    H1(Modifier.classNames("title", "is-1", "has-text-white").toAttrs()) { Text("CAREERS") }
                    P(Modifier.fontFamily(Constants.FONT_FAMILY2).classNames("subtitle", "is-3").toAttrs()) { Text("What We Offer At Braun Equipment") }
                }
            }
        }

        Section(Modifier.fontFamily(Constants.FONT_FAMILY2).classNames("section").toAttrs()) {
            Div(Modifier.classNames("container", "is-max-desktop").toAttrs()) {
                Div(Modifier.classNames("columns").toAttrs()) {

                    //Employee Perks/Privileges?
                    Div(Modifier.classNames("column").toAttrs()) {
                        H3(Modifier.classNames("title", "is-3", "has-text-dark", "has-text-centered").toAttrs()) { Text("Employee Privileges") }
                        Div(Modifier.classNames("content", "is-medium").toAttrs()) {
                            Ul(
                                smallListStyle.toModifier()
                                    .width(100.percent)
                                    .margin(10.px)
                                    .classNames("is-flex", "is-justify-content-center", "is-flex-direction-column")
                                    .toAttrs()
                            ) {
                                Li() { Text("Anthem Blue Cross Insurance Packages") }
                                Li() { Text("Vision Insurance") }
                                Li() { Text("Dental Insurance") }
                                Li() { Text("Life Insurance") }
                                Li() { Text("401(k) Retirement Plan With Match") }
                                Li() { Text("Competitive Pay") }
                                Li() { Text("Weekly and Daily Home Time") }
                                Li() { Text("Late Model Equipment") }
                                Li() { Text("Pre-Pass Equipped Trucks") }
                                Li() { Text("Tax Free Per Diem") }
                                Li() { Text("Paid Time Off") }
                            }
                        }
                    }


                    //Download Application
                    Div(Modifier.classNames("column").toAttrs()) {
                        H3(Modifier.classNames("title", "is-3", "has-text-dark", "has-text-centered").toAttrs()) { Text("Download Application") }
                        Div(smallPDFBoxStyle.toModifier().classNames("box", "is-flex", "is-flex-direction-column", "is-justify-content-center",  "mt-6").toAttrs()) {
                            H3(Modifier.classNames("title", "is-4", "has-text-centered", "has-text-dark").toAttrs()) { Text("Braun Equipment Inc.") }
                            P(Modifier.classNames("subtitle", "is-5", "has-text-centered", "has-text-dark").toAttrs()) { Text("Driver Application Form (PDF)") }

                            Button(
                                modifier = Modifier.classNames("button").backgroundColor(Theme.Primary.rgb),
                                onClick = {
                                    context.router.navigateTo(
                                        "https://img1.wsimg.com/blobby/go/dac963b7-ded5-4fc4-97e3-bcae4469fcc5/downloads/Braun%20Equipment%20Inc.%20Driver%20Application%20Form.pdf?ver=1707250462030",
                                        openExternalLinksStrategy = OpenLinkStrategy.IN_NEW_TAB
                                    )
                                }
                            ) { Text("DOWNLOAD") }
                        }
                    }
                }
            }
        }
    }
}